import React, { useState } from "react";

function FormInput(props) {
  const [validate, setValidate] = useState(false);
  const { label, errorMessage, onChange, id, ...inputProps } = props;
  const handleFocus = (e) => {
    setValidate(true);
  };
  return (
    <div className="flex flex-col mt-2">
      {/* <label>{label}</label> */}

      {inputProps.name === "message" ? (
        <textarea
          rows="4"
          className="peer p-4  border-gray-500 border"
          {...inputProps}
          onChange={onChange}
          onBlur={handleFocus}
        />
      ) : (
        <input
          className="peer p-4  border-gray-500 border"
          {...inputProps}
          onChange={onChange}
          onBlur={handleFocus}
        />
      )}
      {/* <span
        className={` ${
          validate ? "invisible peer-invalid:visible" : "invisible"
        }  text-red-600 text-sm`}
      >
        {errorMessage}
      </span> */}
    </div>
  );
}

export default FormInput;
